export enum Tabs {
  Results,
  Payments,
}
